<template>
  <DataListStateful
    title="Должности"
    resource="positions"
    store="positions"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
      },
    };
  },
};
</script>
